import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable, of } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';

import { GlobalStoreService } from '@lib-core/global/services/global-store.service';
import { CmsStoreService } from '@lib-shared/cms/services/cms-store.service';
import { AuthHelperService } from '../services/auth-helper.service';

import { injectAuthFeature } from '@mymill/core/auth';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  private readonly authFeature = injectAuthFeature();
  private readonly cmsStoreService = inject(CmsStoreService);
  private readonly globalStoreService = inject(GlobalStoreService);

  /**
   * constructor
   *
   */
  constructor(
    private authHelperService: AuthHelperService,
    //private authStoreService: AuthStoreService,
  ) {}

  /**
   * canActivate
   *
   */
  public canActivate(
    route: ActivatedRouteSnapshot,
    routeState: RouterStateSnapshot,
  ): Observable<boolean> {
    // if already loggedIn, just return true
    if (this.authFeature.isLoggedIn()) return of(true);

    // check state
    return this.authFeature.state$.pipe(
      filter((authState) => !authState.isLoggingInProgress),
      take(1),
      switchMap((state) => {
        // if not already loggedIn and login not ready, refresh login
        if (!state.isReady) {
          this.authFeature.refreshLogin();
        }

        return this.authFeature.state$;
      }),
      filter((state) => !state.isLoggingInProgress),
      take(1),
      map(() => true),
      /*
      tap(() => {
        this.globalStoreService.initOnLogin();
      }),*/
    );
  }
}
